import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_EV_DEMO_USE_CASE_3_EXP_VIDEO = {
  videoSrc: "EV/Use_case_3_exp.mp4",
  title: "TOWER LEASE CONTRACTS: EXPLAINER VIDEO",
  onClose: () => setCurrentPage(410),
};

export default DATA_EV_DEMO_USE_CASE_3_EXP_VIDEO;
